<template lang="pug">
</template>

<script>
import Vue from 'vue'
import SubscriptionApi from '../apis/subscription'
export default {
  props: {
    invoice_pending: String,
    redirect_path: String
  },
  methods: {
    async checkInvoiceStatus(){
    }
  },
  async mounted(){
    await Vue.nextTick()
    if(this.invoice_pending == "false"){
      this.$store.commit("user/setInvoicePending", false)
    } else {
      this.$store.commit("user/setInvoicePending", true)
    }
  },
  watch: {
    '$store.state.user.invoice_pending': async function (val) {
      if(val == true){
        console.log("invoice_pending!",val)
        const { data } = await SubscriptionApi.check_invoice_status()
        if(!data.continue){
          //console.log(data)
          location.href = this.redirect_path
        }
        await sleep(1000)
        setInterval(async function () {
          console.log('hi')
          const { data } = await SubscriptionApi.check_invoice_status()
          console.log(data)
          if(!data.continue){
            //console.log(data)
            location.href = this.redirect_path
          }
        }.bind(this), 1000*10)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
